import type { Result } from '$lib/analysis/wasm/result';
import type { Time } from '@df/common';
import { z } from 'zod';
import { accountMapSchema } from './account';
import { bookYearSchema } from './periods';
import { voucherSeriesMetadataSchema } from './voucher';
import { voucherSeriesSchema } from './voucher_id';

const ledgerMetadataSchema = z.object({
  bookYear: bookYearSchema,
  accountMap: accountMapSchema,
  voucherSeries: z.map(voucherSeriesSchema, voucherSeriesMetadataSchema),
});
type LedgerMetadata = z.infer<typeof ledgerMetadataSchema>;

type ClientBookYearKey = `${string}:${Time.BookYear}`;

function clientBookYearKey(clientId: string, bookYear: Time.BookYear): ClientBookYearKey {
  return `${clientId}:${bookYear}`;
}

type CompanyLedgerMetadata = Map<ClientBookYearKey, Result<LedgerMetadata>>;

export {
  clientBookYearKey,
  ledgerMetadataSchema,
  type ClientBookYearKey,
  type CompanyLedgerMetadata,
  type LedgerMetadata,
};
